import { FC } from "react";
import Logo from "../../components/svgs/logo";
import BtBackground from "../bt-background/bt-background";
import BtCenter from "../bt-center/bt-center";
import BtColumn from "../bt-column/bt-column";
import BtGrid from "../bt-grid/bt-grid";
import BtRow from "../bt-row/bt-row";
import CraneImage from '../../assets/images/crane.jpg';
import { useTranslation } from 'react-i18next';

const UserInvitationError: FC = () => {
  const [t] = useTranslation('users', { keyPrefix: 'invitationError' });

  return (
    <div className="page-login">
      <BtGrid>
        <BtRow>
          <BtColumn className="bt-w50 first-column bg-white" style={{ padding: '70px 0' }}>
            <BtCenter>
              <div className="align-center bt-w60">
                <div className="m-t-30 m-b-40 d-flex justify-content-center">
                  <Logo size="350px" type="logoWithTitle" />
                </div>
              <h3>{t('pageTitle', 'Länken är ogiltig')}</h3>
              <p>
                {t('intro', 'Den angivna inbjudningskoden är ogiltig eller har gått ut. Begär en ny inbjudningskod.')}
              </p>
            </div>
          </BtCenter>
        </BtColumn>
        <BtColumn className="second-column">
          <BtBackground src={CraneImage} className="bg-login bt-background-position-left" />
        </BtColumn>
      </BtRow>
    </BtGrid>
  </div>
  );
};

export default UserInvitationError;